// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:12.918Z
// Property: Sunchase Apartments (ID: 6767906449165629)
// Collections: 26 amenities, 4 floorplans (live), 44 photos, 65 POIs, 1 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165629",
  "property_external_id": "m211vfl",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/sunchase-apartments-tulsa-ok/m211vfl/",
  "property_google_business_url": "https://www.google.com/maps/place/Sunchase+Tulsa+Apartments/data=!4m2!3m1!1s0x0:0x8701bae4a1f437e8?sa=X&ved=2ahUKEwjZ-dGBgL2SAxX_g4kEHSW-Dq4Q_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "36087948650",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "sunchase-apartments",
  "property_name": "Sunchase Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/sunchase/",
  "property_domain": null,
  "property_address": "8101 East 93rd Street",
  "property_full_address": "8101 East 93rd Street, Tulsa, OK, 74133",
  "property_address_1": "8101 East 93rd Street",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0286",
  "property_address_longitude": "-95.8838",
  "property_email": "sunchasetulsa@caseusa.com",
  "property_phone": "(539) 218-0640",
  "property_call_tracking_phone": "833-772-0865",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Sunchase Apartments in Tulsa, Oklahoma, where comfort meets convenience. Choose from spacious one- and two-bedroom layouts, and enjoy fabulous amenities like a sparkling pool, fitness center, and serene walking trails. The perfect blend of relaxation and recreation awaits—find your new home today by browsing availability or scheduling a tour! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Sunchase Apartments, your ideal retreat in the heart of Tulsa, Oklahoma! Our vibrant community features a variety of thoughtfully designed floor plans, including spacious one and two-bedroom apartments tailored to fit your lifestyle. Each home is equipped with modern amenities like air conditioning, walk-in closets, high-speed internet access, and well-appointed kitchens featuring dishwashers and garbage disposals, offering convenience at every turn.\n\nStep outside and enjoy an array of outstanding amenities that enhance your living experience. Dive into relaxation at our sparkling pool, maintain your fitness routine in our fully-equipped fitness center, and engage in friendly competition on our basketball court. For families, the playground and scenic walking/biking trails provide endless opportunities for fun and outdoor adventure.\n\nOur clubhouse and lounge areas are perfect for hosting gatherings or simply unwinding after a long day, while our dedicated property management team and on-site maintenance ensure your needs are always met. We take pride in offering a smoke-free environment that feels like home, complete with modern conveniences like laundry facilities, trash compactors, and heating options.\n\nAt Sunchase Apartments, you’ll find more than just an apartment; you’ll find a community that fosters connection and comfort. Don’t miss out on the chance to elevate your living experience in Tulsa—browse our availability or schedule a tour today to discover your new home at Sunchase Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-c5c8-74cc-b2e5-70da7b7aa7e6.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings with surrounding parking lots and commercial areas.",
    "public_id": "019fb44b-c5c8-74cc-b2e5-70da7b7aa7e6",
    "storage_key": "property/6767906449165629/019fb44b-c5c8-74cc-b2e5-70da7b7aa7e6.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "416",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.11538461538461",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Pets Welcome",
  "property_pet_policy_description": "Pets Welcome",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://sunchaseapartmentstulsa.securecafe.com/onlineleasing/sunchase-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://sunchaseapartmentstulsa.securecafe.com/residentservices/sunchase-apartments/userlogin.aspx",
  "property_apply_now_url": "https://sunchaseapartmentstulsa.securecafe.com/onlineleasing/sunchase-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-1360-7063-a695-1893602d804c.webp",
  "property_primary_logo_media": {
    "alt_text": "SunChase Apartments logo",
    "public_id": "019cfb48-1360-7063-a695-1893602d804c",
    "storage_key": "property/6767906449165629/019cfb48-1360-7063-a695-1893602d804c.webp",
    "width": 325,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb49-225d-75dc-b897-3b398bfa082e.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb49-225d-75dc-b897-3b398bfa082e",
    "storage_key": "property/6767906449165629/019cfb49-225d-75dc-b897-3b398bfa082e.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb49-3972-7371-8221-ddb26f40c1f1.webp",
  "property_mono_white_logo_media": {
    "alt_text": "SunChase Apartments logo",
    "public_id": "019cfb49-3972-7371-8221-ddb26f40c1f1",
    "storage_key": "property/6767906449165629/019cfb49-3972-7371-8221-ddb26f40c1f1.webp",
    "width": 325,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb49-42a4-7035-9d70-ebc8b3fa5115.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Sunchase Apartments logo",
    "public_id": "019cfb49-42a4-7035-9d70-ebc8b3fa5115",
    "storage_key": "property/6767906449165629/019cfb49-42a4-7035-9d70-ebc8b3fa5115.webp",
    "width": 325,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": "#eae0c8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#d4af37",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 1",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "500 - 725",
  "property_sqft_min": "500",
  "property_sqft_max": "725",
  "property_price_range": "754 - 839",
  "property_price_min": "754",
  "property_price_max": "839",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/SunchaseTulsa/reels/",
  "property_instagram_url": "https://www.instagram.com/sunchasetulsaapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ2e1RioCPtocR6Df0oeS6AYc",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/crown-chase-apartments-tulsa",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sunchase Apartments",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection in Your New Home",
  "property_home_amenities_blurb": "Welcome to Sunchase Apartments in Tulsa, where comfort meets convenience. Choose from our inviting studio, one, or two-bedroom floor plans, each designed with you in mind. Enjoy a refreshing dip in the pool, stay active in our fitness center, or unwind in the clubhouse. Your vibrant lifestyle awaits!",
  "property_home_floorplans_blurb": "Nestled in the vibrant heart of Tulsa, Sunchase Apartments offers a harmonious blend of comfort and style. With a variety of thoughtfully designed floor plans—from cozy studios to spacious two-bedroom layouts—your ideal sanctuary awaits. Browse our available apartment homes and imagine your new life at Sunchase.",
  "property_home_gallery_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, life shines bright! Choose from inviting studio, one, or two-bedroom floor plans that blend comfort with convenience. Enjoy top-notch amenities like a sparkling pool, state-of-the-art fitness center, and relaxing clubhouse. Picture yourself living here—embrace a vibrant lifestyle in a welcoming community!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Tulsa, Sunchase Apartments offers vibrant one and two-bedroom floor plans that complement your lifestyle. Immerse yourself in a lively neighborhood filled with local favorites, parks, and entertainment. Dive into the nearby attractions that make our community a perfect place to call home.",
  "property_home_reviews_blurb": "At Sunchase Apartments in Tulsa, enjoy the tranquility of a welcoming community where \"management is always very nice and helpful.\" Experience prompt maintenance and friendly neighbors, creating a peaceful sanctuary for you to call home. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, our vibrant community is surrounded by top educational institutions, including Oral Roberts University and Jenks High School, making it an ideal home for students and families alike. See what's around our community and uncover local favorites and nearby points of interest!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sunchase Apartments in Tulsa, indulge in a lifestyle where comfort meets convenience. Our diverse floor plans cater to every need, while amenities like a sparkling pool, state-of-the-art fitness center, and serene walking trails elevate your living experience. Join us today and embrace a vibrant community designed for you!",
  "property_applynow_blurb": "At Sunchase Apartments in Tulsa, experience a vibrant community filled with amenities tailored for contemporary living. Enjoy refreshing swims in the pool, energizing workouts in the fitness center, and leisurely strolls along scenic walking trails. With beautifully designed one and two-bedroom floor plans, your ideal home awaits. Lease online today!",
  "property_contactus_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Enjoy modern amenities and a vibrant community right outside your door. Have questions? Our leasing team is ready to help—reach out today to start your journey to a new home!",
  "property_faqs_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, we offer a range of thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Ready to dive into the details? Enrich your living experience by visiting our FAQs page for insights about our vibrant community and what we have to offer.",
  "property_floorplans_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, versatile living awaits. Choose from our stylish one and two-bedroom floor plans, designed for modern comfort and convenience. Each space is thoughtfully crafted to fit your lifestyle. Browse our available apartment homes today and unlock the door to your ideal living environment!",
  "property_gallery_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, daily life is a blend of comfort and convenience. Imagine relishing the sun by the pool, savoring a workout in the fitness center, or unwinding in your stylish apartment with a cozy fireplace. Picture yourself living here—your oasis awaits!",
  "property_interactivemap_blurb": "At Sunchase Apartments in Tulsa, discover vibrant living among our thoughtfully designed one and two-bedroom floor plans. Enjoy premium amenities like a sparkling pool, state-of-the-art fitness center, and inviting clubhouse. Use our interactive community map to find your ideal space and experience life at Sunchase today!",
  "property_pets_blurb": "At Sunchase Apartments in Tulsa, OK, your furry friends are cherished members of our community. With spacious layouts and abundant amenities, you and your pets can enjoy a vibrant lifestyle under the sun. Create joyful moments in our lush surroundings, where comfort meets a pet-friendly atmosphere. Welcome home!",
  "property_referafriend_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, great friends make great neighbors! Our inviting one and two-bedroom plans offer the perfect blend of comfort and style. Refer a friend today and let them experience the warmth of our community while enjoying a vibrant lifestyle together!",
  "property_residentaccess_blurb": "Welcome to Sunchase Apartments in Tulsa, Oklahoma, where comfort meets convenience. Choose from our thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Log in to your resident portal to effortlessly pay rent, schedule maintenance, and access exclusive community updates. Your ideal living experience awaits!",
  "property_reviews_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, residents rave about our “nice and helpful” management and “prompt” maintenance. Enjoy a quiet living environment with friendly neighbors, all contributing to a welcoming community. Curious about life here? See what our residents have to say about living at our community!",
  "property_created_at": "1753982392708",
  "property_scheduletour_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Experience a vibrant community that feels like home. Want to know more? Check out our resident testimonials and see why Sunchase is the perfect place to begin your next chapter!",
  "property_thankyou_blurb": "Thank you for reaching out! At Sunchase Apartments in vibrant Tulsa, Oklahoma, we offer spacious one and two-bedroom floor plans tailored for your lifestyle. Keep an eye on your inbox; a member of our friendly team will be in touch shortly to help you find your perfect home.",
  "property_virtualtours_blurb": "At Sunchase Apartments in Tulsa, Oklahoma, find your perfect home among our inviting one and two-bedroom floor plans. With spacious layouts and modern amenities, our community is designed for comfort. Experience it all—take a virtual tour and envision your new lifestyle in this vibrant neighborhood!",
  "property_copyright": "2025 All Rights Reserved. Sunchase Apartments",
  "property_seo_title_home": "Sunchase Apartments | Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Step into comfort at Sunchase Apartments in Tulsa! Enjoy spacious one and two-bedroom layouts, resort-style amenities, and a vibrant community. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Tulsa, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal space at Sunchase Apartments in Tulsa! Choose from stylish one and two-bedroom floor plans designed for comfort. Browse now!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at Sunchase Apartments in Tulsa! Enjoy top-notch amenities like a pool, fitness center, and scenic trails. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "\"Imagine the perfect blend of comfort and convenience at Sunchase Apartments in Tulsa. Explore vibrant amenities and stunning floor plans. Your new home awaits!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Sunchase Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Sunchase Apartments in Tulsa! Take a virtual tour of our one and two-bedroom homes, and find your perfect oasis today!",
  "property_seo_title_interactivemap": "Interactive Map | Sunchase Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Sunchase Apartments in Tulsa, OK! Check our interactive map for floor plans, pricing, and a vibrant community filled with amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Sunchase Apartments in Tulsa! Dive into local favorites and discover hidden gems just steps from your new home. ",
  "property_seo_title_contact": "Contact Us | Sunchase Apartments",
  "property_seo_description_contact": "Reach out to the Sunchase Apartments team in Tulsa! Inquire about our one and two-bedroom floor plans and let us help you find your perfect home today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "\"Got questions? Our Sunchase Apartments FAQ in Tulsa covers everything from amenities to floor plans. Get the answers you need and feel right at home!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Join the Sunchase Apartments community in Tulsa! Our residents love the spacious layouts and amazing amenities. See what they have to say about life here!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Experience comfort and convenience at Sunchase Apartments in Tulsa. From our refreshing pool to spacious floor plans, your new home awaits—apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Sunchase Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Sunchase Apartments in Tulsa! Log in to your resident portal to pay rent, schedule maintenance, and manage your home with ease.",
  "property_seo_title_referafriend": "Refer A Friend | Sunchase Apartments",
  "property_seo_description_referafriend": "Refer a friend to Sunchase Apartments in Tulsa! Great friends make great neighbors—share your love for our vibrant community and enjoy exclusive rewards!",
  "property_seo_title_scheduletour": "Schedule a Tour | Sunchase Apartments",
  "property_seo_description_scheduletour": "Experience comfort at Sunchase Apartments in Tulsa! Schedule your tour today and step into your future home with modern amenities and vibrant community living.",
  "property_seo_title_privacy": "Privacy Policy | Sunchase Apartments",
  "property_seo_description_privacy": "Your peace of mind matters! At Sunchase Apartments in Tulsa, we prioritize your privacy. Learn how we safeguard your information in our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Sunchase Apartments",
  "property_seo_description_accessibility": "At Sunchase Apartments in Tulsa, we prioritize digital accessibility for all. Join our vibrant community that embraces inclusion and connection for everyone!",
  "property_seo_title_sitemap": "Sitemap | Sunchase Apartments",
  "property_seo_description_sitemap": "Unlock the layout of your future home at Sunchase Apartments in Tulsa. Navigate our sitemap to envision your ideal living experience today!",
  "property_seo_title_thankyou": "Thank You | Sunchase Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of the Sunchase Apartments team in Tulsa will connect with you soon to help you find your perfect home. ",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865834690",
  "amenities": [
    {
      "id": "ec_ce839332dcc7ad483da52b85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127781812",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84fad3a53f2027e3dc803531",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127397184",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f8b420d4a26304a5d53abc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127397185",
      "title": "Two Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30e1aa8465bf0308e5075cb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127397186",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a03c53366bdaa69fe6e3da1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127397187",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a6a4b02602e51a09a7000cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127397188",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0ce4773cf29a3852ec3c67b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127397190",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5bdb2bfe9ca6d0d93f4abeb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127397191",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32038e826d52b8633862cfa7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127397192",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f327ada0d27bd6cb6cb5821",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127397193",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_486f440e9af89c033a69bc9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "128017290",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2c6a0155586fd4c6381239a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "128050552",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa0ad8e11a4e249494090c5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127781803",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fca0c09344d219b206ef367",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398643",
      "title": "W/D Hookup in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eea63be2c60445eb6122ed8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398644",
      "title": "Fireplace in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a977cf1736585f866a63cedb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398645",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1739868d8986593e5cb3afd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398646",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32353e8a02262bb15c24a5a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398647",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdc827627416505da666cec9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398648",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fe7d8080fcee7929f6f3205",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398649",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad7ad09881345df43c7cb894",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398650",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fe8cc2124694773ca72ba2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398651",
      "title": "Extra Storage in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73756c7ae53f1172e4113df0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398652",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d89907faa731b4846a4ef8b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398653",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff55d19af9c34e2fd8e947d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398654",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f2c50160c6f99759cabb9db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "yardi",
      "external_id": "127398655",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_282c6463-f38e-4fd2-87eb-0dd33323a2c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-a09f-7688-9eaa-80377907ba1a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with walkways and green spaces.",
        "public_id": "019faa21-a09f-7688-9eaa-80377907ba1a",
        "storage_key": "property/6767906449165629/019faa21-a09f-7688-9eaa-80377907ba1a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings, showcasing the walkways, well-maintained green spaces, and exterior architecture.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with walkways and green spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8375133b-a5ad-4d3f-a2a5-d7944cfc55ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-953d-710c-a6d3-0a7e5e31a957.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with manicured lawn and walkways.",
        "public_id": "019faa21-953d-710c-a6d3-0a7e5e31a957",
        "storage_key": "property/6767906449165629/019faa21-953d-710c-a6d3-0a7e5e31a957.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Well-maintained apartment building exterior featuring lush green lawns and clean walkways, creating a welcoming atmosphere for residents.",
      "link": "",
      "alt_text": "Apartment building exterior with manicured lawn and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b1ffe48d-8a46-44ad-bb33-a7c2929e5b02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-7d11-72e9-9c78-b8c624f01087.webp",
      "image_media": {
        "alt_text": "Sidewalk leading to apartment buildings with a pool area to the left.",
        "public_id": "019faa21-7d11-72e9-9c78-b8c624f01087",
        "storage_key": "property/6767906449165629/019faa21-7d11-72e9-9c78-b8c624f01087.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "A paved walkway winds between the apartment buildings and a fenced-in pool area, showcasing the property's community amenities.",
      "link": "",
      "alt_text": "Sidewalk leading to apartment buildings with a pool area to the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d2309aed-f2c5-458b-8ffc-4e933c67a015",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-7576-73ca-ae32-a9f326cad56d.webp",
      "image_media": {
        "alt_text": "Laundry room with rows of washers and dryers.",
        "public_id": "019faa21-7576-73ca-ae32-a9f326cad56d",
        "storage_key": "property/6767906449165629/019faa21-7576-73ca-ae32-a9f326cad56d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers and dryers for residents.",
      "link": "",
      "alt_text": "Laundry room with rows of washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_69aa5d27-6982-4016-89b8-2e38ffde8629",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-73e6-7457-b689-d3ee4f1e771b.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool with rock waterfall and lounge seating",
        "public_id": "019faa21-73e6-7457-b689-d3ee4f1e771b",
        "storage_key": "property/6767906449165629/019faa21-73e6-7457-b689-d3ee4f1e771b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our indoor swimming pool, complete with a unique rock waterfall feature and comfortable lounge seating areas. Perfect for relaxation year-round.",
      "link": "",
      "alt_text": "Indoor swimming pool with rock waterfall and lounge seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ef4e1478-c473-40f2-8c17-db131083f7f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-7265-70ed-81d9-b33362906569.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and tables.",
        "public_id": "019faa21-7265-70ed-81d9-b33362906569",
        "storage_key": "property/6767906449165629/019faa21-7265-70ed-81d9-b33362906569.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded seating areas.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_308fc9ce-2767-4ab6-9263-4d0b8207efe6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-7216-751b-8928-5236dafee910.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with large windows.",
        "public_id": "019faa21-7216-751b-8928-5236dafee910",
        "storage_key": "property/6767906449165629/019faa21-7216-751b-8928-5236dafee910.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush greenery. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_53ca527f-790d-4289-bf50-900fd07fae91",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-5a4e-72b0-9433-ec50c214bb37.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool with rocks and waterfall feature.",
        "public_id": "019faa21-5a4e-72b0-9433-ec50c214bb37",
        "storage_key": "property/6767906449165629/019faa21-5a4e-72b0-9433-ec50c214bb37.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our stunning indoor pool, complete with a unique rock and waterfall design for a spa-like experience.",
      "link": "",
      "alt_text": "Indoor swimming pool with rocks and waterfall feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c98f99c3-707a-42b7-af7c-ef7d80bd2128",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-6c3f-744e-b599-40286ee8f308.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs with apartment buildings in the background.",
        "public_id": "019faa21-6c3f-744e-b599-40286ee8f308",
        "storage_key": "property/6767906449165629/019faa21-6c3f-744e-b599-40286ee8f308.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. A perfect oasis for relaxation.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c075343-e223-4fb5-a79b-d3be03aa2042",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-62fc-736f-bf9d-7c5c325807a0.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub.",
        "public_id": "019faa21-62fc-736f-bf9d-7c5c325807a0",
        "storage_key": "property/6767906449165629/019faa21-62fc-736f-bf9d-7c5c325807a0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a vanity with a sink and storage, a toilet, and a shower/tub combo with a decorative curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51e32e19-5a14-4b57-a696-9a85f1e01013",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-5530-74df-ad45-968735f78892.webp",
      "image_media": {
        "alt_text": "Bedroom with queen-size bed, nightstand, and window.",
        "public_id": "019faa21-5530-74df-ad45-968735f78892",
        "storage_key": "property/6767906449165629/019faa21-5530-74df-ad45-968735f78892.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, a stylish nightstand with a lamp, and a window offering natural light.",
      "link": "",
      "alt_text": "Bedroom with queen-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b02c231-e1d1-4f89-bb7e-a66ecce1feed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-5d31-7304-a74c-efddb3c1bb76.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool with rock waterfall and lounge seating.",
        "public_id": "019faa21-5d31-7304-a74c-efddb3c1bb76",
        "storage_key": "property/6767906449165629/019faa21-5d31-7304-a74c-efddb3c1bb76.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a relaxing swim in our indoor pool, complete with a beautiful rock waterfall and ample lounge seating.",
      "link": "",
      "alt_text": "Indoor swimming pool with rock waterfall and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_73a252ef-f183-4d07-bed8-9297c2b62284",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-5714-76f7-a7e7-03258dc9d961.webp",
      "image_media": {
        "alt_text": "Indoor pool area with a wooden deck, seating, rock waterfall, and lush greenery.",
        "public_id": "019faa21-5714-76f7-a7e7-03258dc9d961",
        "storage_key": "property/6767906449165629/019faa21-5714-76f7-a7e7-03258dc9d961.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our indoor pool area, featuring a serene atmosphere with a wooden deck, comfortable seating, and a beautiful rock waterfall.",
      "link": "",
      "alt_text": "Indoor pool area with a wooden deck, seating, rock waterfall, and lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c3a63b6-4113-407f-b539-8b372e4fa14f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-4f49-7229-b301-1cc9d91f25b1.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a sink, toilet, and shower/tub combo.",
        "public_id": "019faa21-4f49-7229-b301-1cc9d91f25b1",
        "storage_key": "property/6767906449165629/019faa21-4f49-7229-b301-1cc9d91f25b1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and clean bathroom featuring a modern vanity, toilet, and a bathtub with shower.",
      "link": "",
      "alt_text": "Clean bathroom with a sink, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f997e54-5a8e-48cb-a9d9-55079fe52aeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-5678-744d-9c38-2283fd04e2c9.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool with rock features and lounge chairs.",
        "public_id": "019faa21-5678-744d-9c38-2283fd04e2c9",
        "storage_key": "property/6767906449165629/019faa21-5678-744d-9c38-2283fd04e2c9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a relaxing swim in our beautiful indoor pool, featuring a unique rock waterfall and ample space for lounging.",
      "link": "",
      "alt_text": "Indoor swimming pool with rock features and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_42de9a37-1957-498d-8156-98f9a6c0df3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-46ea-724c-bb9d-df4d1a31a37a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "019faa21-46ea-724c-bb9d-df4d1a31a37a",
        "storage_key": "property/6767906449165629/019faa21-46ea-724c-bb9d-df4d1a31a37a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, elegant nightstand with lamp, and a window with blinds and curtains, offering a peaceful retreat.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ee1d822e-8594-42c2-aa33-5379e1b2bc37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-3e09-73cd-bb76-8afd9e2de9f3.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances and wooden cabinets",
        "public_id": "019faa21-3e09-73cd-bb76-8afd9e2de9f3",
        "storage_key": "property/6767906449165629/019faa21-3e09-73cd-bb76-8afd9e2de9f3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring black appliances including a refrigerator and oven, complemented by warm wooden cabinetry and a speckled countertop.",
      "link": "",
      "alt_text": "Kitchen with black appliances and wooden cabinets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b5bb597c-a909-4d7e-8394-276aa20d295f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-3076-752e-a275-c1e0eb104d7c.webp",
      "image_media": {
        "alt_text": "Bright and airy living room with a sofa, armchairs, and a coffee table.",
        "public_id": "019faa21-3076-752e-a275-c1e0eb104d7c",
        "storage_key": "property/6767906449165629/019faa21-3076-752e-a275-c1e0eb104d7c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy comfortable living in this beautifully appointed apartment, featuring a spacious living area perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Bright and airy living room with a sofa, armchairs, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c712fe2-76e0-4c60-89b3-6535508a75b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-2641-7529-9c62-f7622dc2b2dc.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with wood cabinets.",
        "public_id": "019faa21-2641-7529-9c62-f7622dc2b2dc",
        "storage_key": "property/6767906449165629/019faa21-2641-7529-9c62-f7622dc2b2dc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy dining area adjacent to a kitchen featuring warm wood cabinetry and ample counter space. Perfect for enjoying meals at home.",
      "link": "",
      "alt_text": "Dining area and kitchen with wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9617faf-3c23-4971-ab73-1d5bf4847434",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-2649-772b-9f4d-090b6825be86.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, sink, dishwasher, and refrigerator.",
        "public_id": "019faa21-2649-772b-9f4d-090b6825be86",
        "storage_key": "property/6767906449165629/019faa21-2649-772b-9f4d-090b6825be86.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample storage with wooden cabinets, granite countertops, a stainless steel sink, and a dishwasher. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, sink, dishwasher, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c405123c-7216-436e-a25e-99d83c5b5087",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-3cc0-738c-bcc9-503be9c487c0.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel sink, black refrigerator, and oven.",
        "public_id": "019faa21-3cc0-738c-bcc9-503be9c487c0",
        "storage_key": "property/6767906449165629/019faa21-3cc0-738c-bcc9-503be9c487c0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample wooden cabinetry, granite countertops, a double-bowl sink, and black appliances, including a refrigerator and oven.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel sink, black refrigerator, and oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51b0c7d5-d91a-404a-b0d2-4c5d888390de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-2392-7502-8f5a-6a64b399d055.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and balcony access.",
        "public_id": "019faa21-2392-7502-8f5a-6a64b399d055",
        "storage_key": "property/6767906449165629/019faa21-2392-7502-8f5a-6a64b399d055.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A beautifully staged living room featuring a comfortable sofa, an armchair, a stylish coffee table, and access to a private balcony. The warm decor and ample natural light create a welcoming atmosphere.",
      "link": "",
      "alt_text": "Living room with sofa, armchair, coffee table, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1edd4c39-6881-44e9-85a4-932daaaed308",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-25a7-71a2-8a1e-9e3804c72476.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, accent chair, coffee table, TV, and access to a balcony.",
        "public_id": "019faa21-25a7-71a2-8a1e-9e3804c72476",
        "storage_key": "property/6767906449165629/019faa21-25a7-71a2-8a1e-9e3804c72476.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting living room, featuring comfortable seating, a large flat-screen TV, and a private balcony perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Living room with sectional sofa, accent chair, coffee table, TV, and access to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d13618df-90b7-4d1e-844c-76e3fa915be4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-2dc1-75fb-ab0e-fddc8b61eb82.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and a small kitchen area in the background.",
        "public_id": "019faa20-2dc1-75fb-ab0e-fddc8b61eb82",
        "storage_key": "property/6767906449165629/019faa20-2dc1-75fb-ab0e-fddc8b61eb82.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A cozy dining area featuring a round table with four chairs, adjacent to a functional kitchen space with wood cabinetry and essential appliances.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and a small kitchen area in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_65269819-0088-4708-8594-c30327a31ecc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-2cc3-72b9-a972-918c354a84c4.webp",
      "image_media": {
        "alt_text": "View of the community pool area from a balcony.",
        "public_id": "019faa20-2cc3-72b9-a972-918c354a84c4",
        "storage_key": "property/6767906449165629/019faa20-2cc3-72b9-a972-918c354a84c4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool surrounded by lounge chairs and umbrellas. Enjoy the lush green landscaping and the beautiful community exterior.",
      "link": "",
      "alt_text": "View of the community pool area from a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_48d815be-dcf3-4cfb-a205-80772e23c868",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-2c94-709c-929f-6955b6fceb77.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white countertops, stainless steel dishwasher, refrigerator, and a coffee maker.",
        "public_id": "019faa20-2c94-709c-929f-6955b6fceb77",
        "storage_key": "property/6767906449165629/019faa20-2c94-709c-929f-6955b6fceb77.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample cabinet space, a dishwasher, and a coffee maker for your morning routine.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white countertops, stainless steel dishwasher, refrigerator, and a coffee maker.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc90d447-232e-4650-83b2-6a474b962a83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-11ec-75dc-9032-768f899fb67c.webp",
      "image_media": {
        "alt_text": "Living room with a TV, coffee table, couch, and balcony access.",
        "public_id": "019faa20-11ec-75dc-9032-768f899fb67c",
        "storage_key": "property/6767906449165629/019faa20-11ec-75dc-9032-768f899fb67c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a large TV, rustic coffee table, comfortable seating, and a sliding glass door leading to a private balcony.",
      "link": "",
      "alt_text": "Living room with a TV, coffee table, couch, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_136f3865-0cd5-407d-941c-2838b62702f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-1578-71b9-a451-6da58299ccc3.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
        "public_id": "019faa20-1578-71b9-a451-6da58299ccc3",
        "storage_key": "property/6767906449165629/019faa20-1578-71b9-a451-6da58299ccc3.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub, toilet, and a vanity with a sink.",
      "link": "",
      "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c4689ac-6015-4669-87f4-173b4db7f0e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-175e-712c-acbc-962199272774.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sofa, armchair, coffee table, and dining area.",
        "public_id": "019faa20-175e-712c-acbc-962199272774",
        "storage_key": "property/6767906449165629/019faa20-175e-712c-acbc-962199272774.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring comfortable seating, a coffee table, and elegant decor. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with a gray sofa, armchair, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b1827e5e-8f57-4fbb-9089-4aaf80663bf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-0e7c-70ac-a320-cff243b8493e.webp",
      "image_media": {
        "alt_text": "View of the community pool and lounge chairs from a balcony.",
        "public_id": "019faa20-0e7c-70ac-a320-cff243b8493e",
        "storage_key": "property/6767906449165629/019faa20-0e7c-70ac-a320-cff243b8493e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool in this beautiful community amenity. Perfect for sunny days and unwinding.",
      "link": "",
      "alt_text": "View of the community pool and lounge chairs from a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_899f3220-799a-4fe6-94c9-c73f8742483c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-dead-711f-808a-0a879ac50825.webp",
      "image_media": {
        "alt_text": "Modern living room with couch, armchair, coffee table, and dining table with chairs.",
        "public_id": "019faa1f-dead-711f-808a-0a879ac50825",
        "storage_key": "property/6767906449165629/019faa1f-dead-711f-808a-0a879ac50825.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room featuring comfortable seating, a stylish coffee table, and a dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with couch, armchair, coffee table, and dining table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad6f732d-f8a2-479c-bb87-437a6deb6d02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-ec0a-76da-b17d-c9c1ae22e560.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a queen-sized bed, wooden furniture, and decorative wall art.",
        "public_id": "019faa1f-ec0a-76da-b17d-c9c1ae22e560",
        "storage_key": "property/6767906449165629/019faa1f-ec0a-76da-b17d-c9c1ae22e560.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen bed and elegant wooden furnishings.",
      "link": "",
      "alt_text": "A cozy bedroom with a queen-sized bed, wooden furniture, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0632d6cd-78d5-4edc-9938-ef37b7d590c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-ea66-77e9-bd62-2853fa2c8d56.webp",
      "image_media": {
        "alt_text": "Compact kitchen with white refrigerator, wooden cabinets, stove, and sink.",
        "public_id": "019faa1f-ea66-77e9-bd62-2853fa2c8d56",
        "storage_key": "property/6767906449165629/019faa1f-ea66-77e9-bd62-2853fa2c8d56.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A compact kitchen featuring a white refrigerator, warm wooden cabinetry, a stove, and a sink area, perfect for efficient living.",
      "link": "",
      "alt_text": "Compact kitchen with white refrigerator, wooden cabinets, stove, and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4872b300-b80f-4638-9fb4-9eda7ce91fdf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-e373-7523-b2aa-d8d6d62af2a6.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and a TV displaying a beach scene.",
        "public_id": "019faa1f-e373-7523-b2aa-d8d6d62af2a6",
        "storage_key": "property/6767906449165629/019faa1f-e373-7523-b2aa-d8d6d62af2a6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable sofa, decorative wall art, and entertainment center.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and a TV displaying a beach scene.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_559fddaf-6141-4758-af8d-f3bbe94408df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-e43b-710f-a8a0-095ad6ff8781.webp",
      "image_media": {
        "alt_text": "Dining nook with a round table and two chairs",
        "public_id": "019faa1f-e43b-710f-a8a0-095ad6ff8781",
        "storage_key": "property/6767906449165629/019faa1f-e43b-710f-a8a0-095ad6ff8781.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy dining nook with a round table and two chairs, perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining nook with a round table and two chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed12090c-3b4c-4a27-8a38-3362450d5ab7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-c1e9-756a-bc85-30c1dde6d625.webp",
      "image_media": {
        "alt_text": "Multifamily property gym with cardio machines and weight equipment.",
        "public_id": "019faa1f-c1e9-756a-bc85-30c1dde6d625",
        "storage_key": "property/6767906449165629/019faa1f-c1e9-756a-bc85-30c1dde6d625.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio machines and weight training equipment for a complete workout.",
      "link": "",
      "alt_text": "Multifamily property gym with cardio machines and weight equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2cf27452-40b1-4f98-ac66-fc4c931ed419",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-c175-768d-b56a-f1bb8c1fe1e4.webp",
      "image_media": {
        "alt_text": "Gym with various cardio and strength training equipment.",
        "public_id": "019faa1f-c175-768d-b56a-f1bb8c1fe1e4",
        "storage_key": "property/6767906449165629/019faa1f-c175-768d-b56a-f1bb8c1fe1e4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our residents enjoy a fully equipped fitness center with treadmills, ellipticals, stationary bikes, and weight machines.",
      "link": "",
      "alt_text": "Gym with various cardio and strength training equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b698865-9788-4b8b-8263-95aa9868c2e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-c0bf-776c-ac95-76b26a5011b5.webp",
      "image_media": {
        "alt_text": "Curved balcony with two chairs and a small table, overlooking the property's courtyard.",
        "public_id": "019faa1f-c0bf-776c-ac95-76b26a5011b5",
        "storage_key": "property/6767906449165629/019faa1f-c0bf-776c-ac95-76b26a5011b5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the outdoors on your private balcony, featuring comfortable seating and scenic views of the courtyard.",
      "link": "",
      "alt_text": "Curved balcony with two chairs and a small table, overlooking the property's courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45d8b6c7-313e-4631-ac42-f5dbbf6ea1f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-b4eb-76af-9c99-a534a4030256.webp",
      "image_media": {
        "alt_text": "Stylish communal lounge area with a fireplace, comfortable seating, and modern decor.",
        "public_id": "019faa1f-b4eb-76af-9c99-a534a4030256",
        "storage_key": "property/6767906449165629/019faa1f-b4eb-76af-9c99-a534a4030256.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed communal lounge, featuring a cozy fireplace and elegant furnishings.",
      "link": "",
      "alt_text": "Stylish communal lounge area with a fireplace, comfortable seating, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2f9cd354-4769-428d-878c-de8fe68c878a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-ab8f-7332-9be4-17ef9bdcf327.webp",
      "image_media": {
        "alt_text": "Interior lounge area with fireplace, seating, and a large table.",
        "public_id": "019faa1f-ab8f-7332-9be4-17ef9bdcf327",
        "storage_key": "property/6767906449165629/019faa1f-ab8f-7332-9be4-17ef9bdcf327.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lounge area, featuring a cozy fireplace and comfortable seating perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Interior lounge area with fireplace, seating, and a large table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f01f5bf-5c51-40d9-8783-4cd85098fffb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-79f1-75f2-96d1-2bc597a70877.webp",
      "image_media": {
        "alt_text": "Kitchen with white oven, wooden cabinets, and framed abstract art.",
        "public_id": "019faa1f-79f1-75f2-96d1-2bc597a70877",
        "storage_key": "property/6767906449165629/019faa1f-79f1-75f2-96d1-2bc597a70877.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A charming kitchen featuring a white oven, classic wooden cabinetry, and decorative framed art on the wall, creating a warm and inviting atmosphere.",
      "link": "",
      "alt_text": "Kitchen with white oven, wooden cabinets, and framed abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2326c964-198e-4903-b745-711b3902d38c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-8600-7554-97ae-4f7e907e1f45.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, and window.",
        "public_id": "019faa1f-8600-7554-97ae-4f7e907e1f45",
        "storage_key": "property/6767906449165629/019faa1f-8600-7554-97ae-4f7e907e1f45.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a king-size bed with a patterned duvet, a wooden nightstand with a lamp, and a window with blinds.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c13d7ca8-f802-400d-832d-13160511541e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-793a-739e-91aa-bb1475c5ba38.webp",
      "image_media": {
        "alt_text": "Sunchase Apartments monument sign with landscaping and flags.",
        "public_id": "019faa1f-793a-739e-91aa-bb1475c5ba38",
        "storage_key": "property/6767906449165629/019faa1f-793a-739e-91aa-bb1475c5ba38.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Sunchase Apartments, beautifully situated with lush landscaping, decorative flags, and an inviting monument sign.",
      "link": "",
      "alt_text": "Sunchase Apartments monument sign with landscaping and flags.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b0c215fa-d784-41cf-9240-81cb5395c98a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-743b-733a-8b9b-c2c661d57eef.webp",
      "image_media": {
        "alt_text": "Property entrance with a burgundy overhang and a sunburst logo on the side.",
        "public_id": "019faa1f-743b-733a-8b9b-c2c661d57eef",
        "storage_key": "property/6767906449165629/019faa1f-743b-733a-8b9b-c2c661d57eef.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our property, featuring a grand entrance with a striking sunburst logo and well-maintained landscaping.",
      "link": "",
      "alt_text": "Property entrance with a burgundy overhang and a sunburst logo on the side.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_648f5c83-617b-41a2-b230-cd0b934a5d4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-1603-713f-bb53-ca1a93693f83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-1603-713f-bb53-ca1a93693f83",
        "storage_key": "property/6767906449165629/019d20b0-1603-713f-bb53-ca1a93693f83.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-58b4-741d-9699-e7e38f4464ee",
        "storage_key": "property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_84031c75-a939-4740-87a7-38caefbb4993",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-1609-7699-ac8c-f7f65a360008.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-1609-7699-ac8c-f7f65a360008",
        "storage_key": "property/6767906449165629/019d20b0-1609-7699-ac8c-f7f65a360008.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-58b4-741d-9699-e7e38f4464ee",
        "storage_key": "property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5c2c786f-b859-42a6-9742-4d6de6c797e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-1811-70b6-a901-53f1d413390d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-1811-70b6-a901-53f1d413390d",
        "storage_key": "property/6767906449165629/019d20b0-1811-70b6-a901-53f1d413390d.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-58b4-741d-9699-e7e38f4464ee",
        "storage_key": "property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_a82e9098-c28b-4bd8-bc88-26c8ffa7ee11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-160a-74dd-b77b-a333be9f7417.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-160a-74dd-b77b-a333be9f7417",
        "storage_key": "property/6767906449165629/019d20b0-160a-74dd-b77b-a333be9f7417.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-58b4-741d-9699-e7e38f4464ee",
        "storage_key": "property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_5fb5aa1e-e722-42b4-888d-d63291c79f8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-1c55-7095-a1d3-b062d8bc7979.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-1c55-7095-a1d3-b062d8bc7979",
        "storage_key": "property/6767906449165629/019d20b0-1c55-7095-a1d3-b062d8bc7979.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-58b4-741d-9699-e7e38f4464ee",
        "storage_key": "property/6767906449165629/019d20b0-58b4-741d-9699-e7e38f4464ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2c4f4f88-954b-4514-adad-9598a6190e89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-1d0d-7514-9b20-244e9695dd93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-1d0d-7514-9b20-244e9695dd93",
        "storage_key": "property/6767906449165629/019d20b0-1d0d-7514-9b20-244e9695dd93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-582c-7378-ab53-247a87875de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-582c-7378-ab53-247a87875de8",
        "storage_key": "property/6767906449165629/019d20b0-582c-7378-ab53-247a87875de8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1bf6483e-5942-4a6f-8925-9acb71a96b82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-1d8c-77e8-9a3c-d2d1149cef07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-1d8c-77e8-9a3c-d2d1149cef07",
        "storage_key": "property/6767906449165629/019d20b0-1d8c-77e8-9a3c-d2d1149cef07.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-582c-7378-ab53-247a87875de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-582c-7378-ab53-247a87875de8",
        "storage_key": "property/6767906449165629/019d20b0-582c-7378-ab53-247a87875de8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e336ab76-76f3-4f76-a582-629851b7a5aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-1e80-72de-893b-a3daf6e37759.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-1e80-72de-893b-a3daf6e37759",
        "storage_key": "property/6767906449165629/019d20b0-1e80-72de-893b-a3daf6e37759.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5833-74e8-8f1a-78fa1ab1b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5833-74e8-8f1a-78fa1ab1b609",
        "storage_key": "property/6767906449165629/019d20b0-5833-74e8-8f1a-78fa1ab1b609.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c84c28ad-8e6d-4655-b6a9-688990a9377c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-2387-7020-b60a-c545f197c422.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-2387-7020-b60a-c545f197c422",
        "storage_key": "property/6767906449165629/019d20b0-2387-7020-b60a-c545f197c422.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5833-74e8-8f1a-78fa1ab1b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5833-74e8-8f1a-78fa1ab1b609",
        "storage_key": "property/6767906449165629/019d20b0-5833-74e8-8f1a-78fa1ab1b609.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_de13e6c9-72a6-49f1-ad03-ea732adce576",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Market selling organic produce and gluten-free grocery items.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy and organic foods, including fresh produce, a salad bar, and a variety of vitamins and supplements. They also highlight the clean and organized layout, the friendly and helpful staff, and the relaxed shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-2383-704f-ae40-450c6e2df045.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-2383-704f-ae40-450c6e2df045",
        "storage_key": "property/6767906449165629/019d20b0-2383-704f-ae40-450c6e2df045.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5833-74e8-8f1a-78fa1ab1b609.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5833-74e8-8f1a-78fa1ab1b609",
        "storage_key": "property/6767906449165629/019d20b0-5833-74e8-8f1a-78fa1ab1b609.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f2cc7779-644e-4124-95ec-e682da2d719c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-26e8-7625-81c0-57702a07d3d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-26e8-7625-81c0-57702a07d3d5",
        "storage_key": "property/6767906449165629/019d20b0-26e8-7625-81c0-57702a07d3d5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-584c-722f-b094-dbbc0f042f0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-584c-722f-b094-dbbc0f042f0e",
        "storage_key": "property/6767906449165629/019d20b0-584c-722f-b094-dbbc0f042f0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_87b4e3f4-58db-4d91-8361-e1ed5ff0a0bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-2575-7583-8a8a-c6473ce73fa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-2575-7583-8a8a-c6473ce73fa9",
        "storage_key": "property/6767906449165629/019d20b0-2575-7583-8a8a-c6473ce73fa9.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-584c-722f-b094-dbbc0f042f0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-584c-722f-b094-dbbc0f042f0e",
        "storage_key": "property/6767906449165629/019d20b0-584c-722f-b094-dbbc0f042f0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c3d4f433-3ec5-48f2-a804-1c3749235b80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-2974-77fd-b47f-8d1dc7edfe93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-2974-77fd-b47f-8d1dc7edfe93",
        "storage_key": "property/6767906449165629/019d20b0-2974-77fd-b47f-8d1dc7edfe93.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-584c-722f-b094-dbbc0f042f0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-584c-722f-b094-dbbc0f042f0e",
        "storage_key": "property/6767906449165629/019d20b0-584c-722f-b094-dbbc0f042f0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d326cc4d-1dce-4f1d-ac9e-ab698ed9e5d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-2aea-7689-aa46-89e0d17451d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-2aea-7689-aa46-89e0d17451d6",
        "storage_key": "property/6767906449165629/019d20b0-2aea-7689-aa46-89e0d17451d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-584c-722f-b094-dbbc0f042f0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-584c-722f-b094-dbbc0f042f0e",
        "storage_key": "property/6767906449165629/019d20b0-584c-722f-b094-dbbc0f042f0e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1bee8196-836a-4e16-97fa-183f9b643cdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-2da2-76e2-995c-5e69ab390720.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-2da2-76e2-995c-5e69ab390720",
        "storage_key": "property/6767906449165629/019d20b0-2da2-76e2-995c-5e69ab390720.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_c2daeced-0692-47a7-a13e-f859363047af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-2dfd-71e7-8472-ebe9315c3f83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-2dfd-71e7-8472-ebe9315c3f83",
        "storage_key": "property/6767906449165629/019d20b0-2dfd-71e7-8472-ebe9315c3f83.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_ca78f524-0fe8-4731-b71d-f059200db85a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-302c-72cd-acf0-e23d010d491b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-302c-72cd-acf0-e23d010d491b",
        "storage_key": "property/6767906449165629/019d20b0-302c-72cd-acf0-e23d010d491b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_9128a884-cc13-48ec-9536-bc74213317ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-3320-716a-bc23-c09e7d8bf258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-3320-716a-bc23-c09e7d8bf258",
        "storage_key": "property/6767906449165629/019d20b0-3320-716a-bc23-c09e7d8bf258.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_db2d544f-233d-4e53-ad13-5166769af286",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-3321-71af-a787-2a6e3c772cb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-3321-71af-a787-2a6e3c772cb8",
        "storage_key": "property/6767906449165629/019d20b0-3321-71af-a787-2a6e3c772cb8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a2f40417-959f-4633-9966-4ad802bf9e04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-34ae-73ea-a041-2ca49625be0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-34ae-73ea-a041-2ca49625be0b",
        "storage_key": "property/6767906449165629/019d20b0-34ae-73ea-a041-2ca49625be0b.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9452d3e8-1506-4706-af26-eca5e08bcfe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-36d8-74ae-b6e9-2570ecacb865.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-36d8-74ae-b6e9-2570ecacb865",
        "storage_key": "property/6767906449165629/019d20b0-36d8-74ae-b6e9-2570ecacb865.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d903862c-2fc6-4948-a05b-95e26b65b18f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-3924-7468-9cca-897986fd94b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-3924-7468-9cca-897986fd94b9",
        "storage_key": "property/6767906449165629/019d20b0-3924-7468-9cca-897986fd94b9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_878d6fcb-3a6d-450d-a87a-0e34a465e5d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-3920-74f4-8cb3-9fdcadaaa997.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-3920-74f4-8cb3-9fdcadaaa997",
        "storage_key": "property/6767906449165629/019d20b0-3920-74f4-8cb3-9fdcadaaa997.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4d921683-11b8-4534-897e-b4004352477c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "4818 E 80th St Ste A, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, fitness classes, and amenities, including tanning, massage beds, and a sauna. They highlight the clean facilities, friendly staff, and welcoming atmosphere, with people from all walks of life enjoying their workouts. They also like the affordable prices and convenient 24-hour access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-3bef-74bf-b21d-20e62e2633ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-3bef-74bf-b21d-20e62e2633ff",
        "storage_key": "property/6767906449165629/019d20b0-3bef-74bf-b21d-20e62e2633ff.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://10gym.com/south-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406416433432823692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.047648",
      "poi_longitude": "-95.9239656",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-494-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-ITWKKTtocRjAdtGP9OZSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f093d73e-7865-43ac-8e91-cf6461ab7105",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-3d95-751d-a914-4c8525e2a570.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-3d95-751d-a914-4c8525e2a570",
        "storage_key": "property/6767906449165629/019d20b0-3d95-751d-a914-4c8525e2a570.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_d3d1625b-2972-4e92-ba50-89fba468d561",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-400a-7429-89ea-c37a5675bcdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-400a-7429-89ea-c37a5675bcdb",
        "storage_key": "property/6767906449165629/019d20b0-400a-7429-89ea-c37a5675bcdb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d51-747f-b42d-b2453cf44b43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d51-747f-b42d-b2453cf44b43",
        "storage_key": "property/6767906449165629/019d20b0-5d51-747f-b42d-b2453cf44b43.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0d057f7a-f02b-436c-abef-8589948c367e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-4045-768f-8110-1ce3b50fbd85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-4045-768f-8110-1ce3b50fbd85",
        "storage_key": "property/6767906449165629/019d20b0-4045-768f-8110-1ce3b50fbd85.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d51-747f-b42d-b2453cf44b43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d51-747f-b42d-b2453cf44b43",
        "storage_key": "property/6767906449165629/019d20b0-5d51-747f-b42d-b2453cf44b43.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_70c537a9-5f38-4efa-b162-f0b27e1c15c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-425f-77b8-bfcc-e265c776d4d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-425f-77b8-bfcc-e265c776d4d3",
        "storage_key": "property/6767906449165629/019d20b0-425f-77b8-bfcc-e265c776d4d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d92-74a3-89c5-bb4c39933faf",
        "storage_key": "property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_83ec6097-6706-417f-8ab4-c021c70d5f99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-445e-717e-b7ae-5e0fe7453dd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-445e-717e-b7ae-5e0fe7453dd2",
        "storage_key": "property/6767906449165629/019d20b0-445e-717e-b7ae-5e0fe7453dd2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d92-74a3-89c5-bb4c39933faf",
        "storage_key": "property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ad8cfe0a-c7a5-4ca1-8afa-07cdbf457eb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-46df-7379-9510-77f86c9f775c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-46df-7379-9510-77f86c9f775c",
        "storage_key": "property/6767906449165629/019d20b0-46df-7379-9510-77f86c9f775c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d92-74a3-89c5-bb4c39933faf",
        "storage_key": "property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cc41da4a-c47e-445c-9227-2070194163a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-475f-711b-a97a-a1c3ba3d2800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-475f-711b-a97a-a1c3ba3d2800",
        "storage_key": "property/6767906449165629/019d20b0-475f-711b-a97a-a1c3ba3d2800.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d92-74a3-89c5-bb4c39933faf",
        "storage_key": "property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f03bbe06-f0f0-4718-9e41-618d3ee66d55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-4957-72aa-a451-47b47b899e2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-4957-72aa-a451-47b47b899e2a",
        "storage_key": "property/6767906449165629/019d20b0-4957-72aa-a451-47b47b899e2a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d92-74a3-89c5-bb4c39933faf",
        "storage_key": "property/6767906449165629/019d20b0-5d92-74a3-89c5-bb4c39933faf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e04b50e9-a81e-4574-819b-9e95478813d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Tulsa Riverside Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8605 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-4a85-77b2-8186-28f09af0b1cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-4a85-77b2-8186-28f09af0b1cc",
        "storage_key": "property/6767906449165629/019d20b0-4a85-77b2-8186-28f09af0b1cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://flytulsa.com/tulsa-river-side/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887194896589047936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-riverside-airport",
      "poi_latitude": "36.0378532",
      "poi_longitude": "-95.9909439",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-299-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5dd7-726b-b103-094981f8e105.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5dd7-726b-b103-094981f8e105",
        "storage_key": "property/6767906449165629/019d20b0-5dd7-726b-b103-094981f8e105.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-5WQAiUtocRgMiiWxMWF5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3a41cd75-907c-42c2-8e45-536c7a4dd1e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Christiansen Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "8767 S Jack Bates Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-4c76-7629-a38e-fd3808ca3639.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-4c76-7629-a38e-fd3808ca3639",
        "storage_key": "property/6767906449165629/019d20b0-4c76-7629-a38e-fd3808ca3639.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://christiansenaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204997232924193680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiansen-aviation",
      "poi_latitude": "36.0365935",
      "poi_longitude": "-95.9895957",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-299-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5dd7-726b-b103-094981f8e105.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5dd7-726b-b103-094981f8e105",
        "storage_key": "property/6767906449165629/019d20b0-5dd7-726b-b103-094981f8e105.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SWkpQWUtocRkHOu4Z0lgJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e6e88066-c323-4792-8456-3f3187202e76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-4f0f-7606-90b3-2c0c43830d4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-4f0f-7606-90b3-2c0c43830d4f",
        "storage_key": "property/6767906449165629/019d20b0-4f0f-7606-90b3-2c0c43830d4f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_07630ae4-4dd6-4ff3-acfb-fbf914c31613",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-4fe6-771f-96ab-03deb2caaa86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-4fe6-771f-96ab-03deb2caaa86",
        "storage_key": "property/6767906449165629/019d20b0-4fe6-771f-96ab-03deb2caaa86.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cb98b3db-fce0-477b-9a2e-03726947aef2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-517c-70cf-ba87-c413c32bdb68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-517c-70cf-ba87-c413c32bdb68",
        "storage_key": "property/6767906449165629/019d20b0-517c-70cf-ba87-c413c32bdb68.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b6375cb6-f1f4-415a-8ead-ea7858a078c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_99e37335-d12f-4672-806d-62bedeac271b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-52c7-75b8-86e2-0b9d10840bc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d20b0-52c7-75b8-86e2-0b9d10840bc2",
        "storage_key": "property/6767906449165629/019d20b0-52c7-75b8-86e2-0b9d10840bc2.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d20b0-5d36-71dc-9c9e-096d29e0f0f2",
        "storage_key": "property/6767906449165629/019d20b0-5d36-71dc-9c9e-096d29e0f0f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_868f0ba9-2c57-4292-9675-93b0144c8634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Jenks East Elementary School",
      "poi_type": "Education",
      "poi_address": "8925 S Harvard Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jenksps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7666529671605862805&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-east-elementary-school",
      "poi_latitude": "36.033814",
      "poi_longitude": "-95.9378796",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9182-7618-a7da-da4893e9d23e",
        "storage_key": "property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtXopIMyTtocRlUEPCB78ZGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_df460354-c717-4386-9cd7-64c2df82f1d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Jenks East Intermediate",
      "poi_type": "Education",
      "poi_address": "3933 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jenksps.org/o/east-intermediate",
      "poi_directions_map_url": "https://maps.google.com/?cid=15765709535319936513&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-east-intermediate",
      "poi_latitude": "36.03378319999999",
      "poi_longitude": "-95.9326473",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9182-7618-a7da-da4893e9d23e",
        "storage_key": "property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy7xD5yiStocRAc67xEoNy9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ab59eb71-bc3a-4654-9c82-891f12f28fc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Jenks Middle School",
      "poi_type": "Education",
      "poi_address": "3019 E 101st St S, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jenksps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14101611830866602126&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-middle-school",
      "poi_latitude": "36.0187568",
      "poi_longitude": "-95.9426735",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9182-7618-a7da-da4893e9d23e",
        "storage_key": "property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJscJrOHiRtocRjug_Iz_9ssM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9bfc1f7c-0851-40e3-9ad5-cfd8b33bc186",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Jenks High School",
      "poi_type": "Education",
      "poi_address": "205 E B St, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-33cf-73b4-9030-3fee619ed2d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-33cf-73b4-9030-3fee619ed2d1",
        "storage_key": "property/6767906449165629/019d7913-33cf-73b4-9030-3fee619ed2d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jenksps.org/o/high-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=4896344340347075511&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-high-school",
      "poi_latitude": "36.0257108",
      "poi_longitude": "-95.9692903",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9182-7618-a7da-da4893e9d23e",
        "storage_key": "property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ5df6ViRtocRt7thUDxP80M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0be21145-34e5-486b-968c-b47818ae5a1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Regent Preparatory School of Oklahoma",
      "poi_type": "Education",
      "poi_address": "8621 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.rpsok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14629475887245309613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regent-preparatory-school-of-oklahoma",
      "poi_latitude": "36.0378695",
      "poi_longitude": "-95.8851847",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-663-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9182-7618-a7da-da4893e9d23e",
        "storage_key": "property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo_ucj-ONtocRrTZmJc9WBss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5fe3d8c8-faf9-4578-8ca1-dbb3b11b3073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-3f64-77ac-a2fb-29ed617a3e57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3f64-77ac-a2fb-29ed617a3e57",
        "storage_key": "property/6767906449165629/019d7913-3f64-77ac-a2fb-29ed617a3e57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9182-7618-a7da-da4893e9d23e",
        "storage_key": "property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_02616bda-2eec-4dd5-98f7-efd2bfc7c03a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Rogers State University",
      "poi_type": "Education",
      "poi_address": "1701 W Will Rogers Blvd, Claremore, OK 74017, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019dbbe7-85d9-71dc-b8bb-4fedfc36697e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe7-85d9-71dc-b8bb-4fedfc36697e",
        "storage_key": "property/6767906449165629/019dbbe7-85d9-71dc-b8bb-4fedfc36697e.webp",
        "width": 800,
        "height": 436
      },
      "poi_business_url": "https://www.rsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14398246966665814765&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rogers-state-university",
      "poi_latitude": "36.3198517",
      "poi_longitude": "-95.6362596",
      "poi_miles_from_property": "30.6 mi",
      "poi_walking_minutes": "11 hours 14 mins",
      "poi_biking_minutes": "2 hours 54 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 918-343-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9182-7618-a7da-da4893e9d23e",
        "storage_key": "property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk0FF37NQtocR7SJ2vFTZ0Mc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2e398139-07f4-45ff-b1a4-883612fc95c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Holland Hall Middle School",
      "poi_type": "Education",
      "poi_address": "5666 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-478b-724d-87cb-5bb3a65f3ebf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-478b-724d-87cb-5bb3a65f3ebf",
        "storage_key": "property/6767906449165629/019d7913-478b-724d-87cb-5bb3a65f3ebf.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.hollandhall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=823686773055530440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "holland-hall-middle-school",
      "poi_latitude": "36.0447195",
      "poi_longitude": "-95.9145094",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-481-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9182-7618-a7da-da4893e9d23e",
        "storage_key": "property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF0bYLBGStocRyKUpisFSbgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_65550f45-ed1c-497e-bc33-4d8db34daef3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Oklahoma State University-Tulsa",
      "poi_type": "Education",
      "poi_address": "700 N Greenwood Ave, Tulsa, OK 74106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-4ba0-7557-a71e-8a3633625da6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4ba0-7557-a71e-8a3633625da6",
        "storage_key": "property/6767906449165629/019d7913-4ba0-7557-a71e-8a3633625da6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15418720188867322820&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-state-university-tulsa",
      "poi_latitude": "36.1638478",
      "poi_longitude": "-95.9880553",
      "poi_miles_from_property": "14.4 mi",
      "poi_walking_minutes": "5 hours 20 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-594-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9182-7618-a7da-da4893e9d23e",
        "storage_key": "property/6767906449165629/019cfb48-9182-7618-a7da-da4893e9d23e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa2utZoTrtocRxKOU5FFM-tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f6326baa-6eab-4ed4-94b7-a63f43dd9147",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Sake2Me Sushi",
      "poi_type": "Restaurants",
      "poi_address": "9205 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual Japanese restaurant offering all-you-can-eat sushi & sashimi, plus noodles & teriyaki dishes.",
      "poi_long_description": "People say this sushi restaurant offers delicious and fresh sushi, including a wide variety of rolls and sashimi, as well as teriyaki chicken and calamari. They highlight the generous portions, reasonable prices, and the all-you-can-eat option, which they find to be a great value. They also like the chill and relaxed atmosphere, and the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-4b62-718e-b530-1997138a160b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4b62-718e-b530-1997138a160b",
        "storage_key": "property/6767906449165629/019d7913-4b62-718e-b530-1997138a160b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sake2mesushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9793506518580779662&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sake2me-sushi",
      "poi_latitude": "36.061592",
      "poi_longitude": "-95.873192",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-249-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-91c7-7334-8a8e-5aeb1b942d4e",
        "storage_key": "property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeCG1folTIYRjtp6WUqG6Yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_9e789596-3770-42bd-b6c3-0c95a004a117",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Tulsa’s Incredible Food and Fun",
      "poi_type": "Restaurants",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Popular place for parties offering go-karts, rides, games & pizza with an all-you-can-eat buffet.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including pizza, hot dogs, tacos, and a salad bar, and has fun games and attractions like laser tag, bumper cars, and a roller coaster. They also highlight the fun, family-friendly atmosphere and the helpful, friendly staff.\n\nOther reviews mention some games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-4c39-70ae-bfe4-4db0ff2fc817.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4c39-70ae-bfe4-4db0ff2fc817",
        "storage_key": "property/6767906449165629/019d7913-4c39-70ae-bfe4-4db0ff2fc817.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblefoodandfun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-s-incredible-food-and-fun",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-91c7-7334-8a8e-5aeb1b942d4e",
        "storage_key": "property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_0452dfb3-4984-4529-8a2d-7fea7c92f182",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Bricktown Brewery",
      "poi_type": "Restaurants",
      "poi_address": "9409 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual pizza joint specializing in local brews and serving burgers and seafood platters.",
      "poi_long_description": "Diners say this restaurant serves up delicious chicken fried chicken, chicken fried steak, and breakfast burgers, and they praise the Kolsch beer. They also highlight the friendly and attentive service, and the welcoming atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-55de-741f-908a-066524003d0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-55de-741f-908a-066524003d0d",
        "storage_key": "property/6767906449165629/019d7913-55de-741f-908a-066524003d0d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bricktownbrewery.com/location/woodland-hills/?utm_source=gbp&utm_medium=cpc&utm_campaign=bricktown_brewery",
      "poi_directions_map_url": "https://maps.google.com/?cid=4102797412021264681&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bricktown-brewery",
      "poi_latitude": "36.0614101",
      "poi_longitude": "-95.8716959",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-994-4456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-91c7-7334-8a8e-5aeb1b942d4e",
        "storage_key": "property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0bN2wL2NtocRKWHrOIIQ8Dg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8093f53a-7874-46af-92ae-244c954fba47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Uncle Julio's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10333 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Tex-Mex chain serving mesquite-grilled fare & margarita-sangria swirls in a hacienda-style space.",
      "poi_long_description": "People say this Mexican restaurant serves delicious fajitas, homemade tortillas, and margaritas. They also highlight the attentive service and fun, festive atmosphere.\n\nOther reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-5f6b-76bb-88be-42d609c9e74a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5f6b-76bb-88be-42d609c9e74a",
        "storage_key": "property/6767906449165629/019d7913-5f6b-76bb-88be-42d609c9e74a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://unclejulios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8326019147073341189&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uncle-julio-s-mexican-restaurant",
      "poi_latitude": "36.0622881",
      "poi_longitude": "-95.8608222",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-999-0054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-91c7-7334-8a8e-5aeb1b942d4e",
        "storage_key": "property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TjRyvSNtocRBUdoFk32i3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_714a8b30-4c18-475b-8628-84194296f47e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "CHENGDU",
      "poi_type": "Restaurants",
      "poi_address": "6620 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Authentic eatery serving familiar favorites from China's Sichuan province plus Pad Thai.",
      "poi_long_description": "People say this Chinese restaurant serves authentic Asian cuisine, including dumplings, spring rolls, and a variety of entrees. They also highlight the generous portions, reasonable prices, and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-603c-72db-bbf5-a9059a2faa28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-603c-72db-bbf5-a9059a2faa28",
        "storage_key": "property/6767906449165629/019d7913-603c-72db-bbf5-a9059a2faa28.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.chengdufoodtulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3243553498852224338&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chengdu",
      "poi_latitude": "36.0666866",
      "poi_longitude": "-95.8872047",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-615-6008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-91c7-7334-8a8e-5aeb1b942d4e",
        "storage_key": "property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YVUEdiNtocRUu0P3bhqAy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_5d074c45-845d-4497-854c-2dca5af95fc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Carrabba's Italian Grill",
      "poi_type": "Restaurants",
      "poi_address": "11021 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_long_description": "Diners say this Italian restaurant serves up delicious spaghetti and mussels, with many praising the generous portions. They also highlight the attentive and friendly service, as well as the warm and inviting atmosphere.\n\nSome reviews mention the prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-5f11-767e-b8d0-ac8edf5dfe0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5f11-767e-b8d0-ac8edf5dfe0a",
        "storage_key": "property/6767906449165629/019d7913-5f11-767e-b8d0-ac8edf5dfe0a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.carrabbas.com/oklahoma/tulsa/11021-east-71st-street?y_source=1_MTU1MDI5NTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2567335840563463566&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carrabba-s-italian-grill",
      "poi_latitude": "36.0613832",
      "poi_longitude": "-95.8537575",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-254-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-91c7-7334-8a8e-5aeb1b942d4e",
        "storage_key": "property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSNJfUyMtocRjgXqO1gCoSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_fea3224a-10b9-4927-9836-02f4653c0bb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Nola's ...Creole & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "1334 E 15th St, Tulsa, OK 74120, USA",
      "poi_short_description": "Relaxed Cajun and Creole place with a chandelier-lit bar, old-timey photos, and Prohibition era cocktails.",
      "poi_long_description": "People say this Cajun restaurant serves delicious dishes like Voodoo Chicken, shrimp and grits, and boudin balls. They highlight the generous portions, reasonable prices, and fun, speakeasy-like atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-6ad6-76c6-ba32-5bd3de7d097b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6ad6-76c6-ba32-5bd3de7d097b",
        "storage_key": "property/6767906449165629/019d7913-6ad6-76c6-ba32-5bd3de7d097b.webp",
        "width": 1280,
        "height": 1218
      },
      "poi_business_url": "http://www.nolastulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=489749569356745618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nola-s-creole-cocktails",
      "poi_latitude": "36.1400087",
      "poi_longitude": "-95.9748442",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-779-7766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-91c7-7334-8a8e-5aeb1b942d4e",
        "storage_key": "property/6767906449165629/019cfb48-91c7-7334-8a8e-5aeb1b942d4e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21HLopnstocRkstodqPwywY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_c00c4c80-6802-4f65-9e29-9ca75115b076",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Riverwalk Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 Riverwalk Terrace, Jenks, OK 74037, USA",
      "poi_short_description": "Lifestyle center on the Arkansas River and Muscogee (Creek) Nation reservation, with shopping, dining, live music, and a trail system.",
      "poi_long_description": "People say this shopping center offers a great selection of food and snacks, with many mentioning the Mexican grill. They also highlight the fun and peaceful atmosphere, beautiful scenery, and great service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-7499-706e-8fe6-4948afb94855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7499-706e-8fe6-4948afb94855",
        "storage_key": "property/6767906449165629/019d7913-7499-706e-8fe6-4948afb94855.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.jenksriverwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11784666382402635584&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverwalk-crossing",
      "poi_latitude": "36.0256838",
      "poi_longitude": "-95.95905820000002",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-518-6675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9190-753f-b75d-8640b2f7a8cc",
        "storage_key": "property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu9Z8JGCRtocRQMeYD6OLi6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_575cfe8e-c189-4048-8b44-d019ad5b9a58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Hunter Park Pond",
      "poi_type": "Shopping & Retail",
      "poi_address": "Creek Tumpike Trl, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2691387023598245280&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hunter-park-pond",
      "poi_latitude": "36.0293125",
      "poi_longitude": "-95.9110908",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-91c9-774c-9ba6-6c499adf52bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-91c9-774c-9ba6-6c499adf52bd",
        "storage_key": "property/6767906449165629/019cfb48-91c9-774c-9ba6-6c499adf52bd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAufeRtocRoFWrBj26WSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a53cdb1d-0433-44f2-bc74-9437defa66d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Next Generations vintage market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5100 E 11th St, Tulsa, OK 74112, USA",
      "poi_short_description": "Antiques, books, records and toys crammed into a lively flea market-style space.",
      "poi_long_description": "People say this antique store offers a wide variety of cool and interesting trinkets, including old records, photo books, and vintage toys. They highlight the reasonable prices and the friendly people working there. They also like the large size of the store, which can be explored for hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-72d5-708d-a001-988bf4105656.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-72d5-708d-a001-988bf4105656",
        "storage_key": "property/6767906449165629/019d7913-72d5-708d-a001-988bf4105656.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5348254744366515469&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "next-generations-vintage-market",
      "poi_latitude": "36.1476505",
      "poi_longitude": "-95.9196197",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-551-7091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9190-753f-b75d-8640b2f7a8cc",
        "storage_key": "property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo-yiLW3ttocRDYVDjlrROEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_f9baeca7-4f8d-44ab-bca4-a61861fcacc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "River Spirit Casino Resort",
      "poi_type": "Shopping & Retail",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Riverside casino offering a steakhouse, casual eateries, table & electronic gaming, & weekend shows.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and entertainment venues, including a concert venue and a sports bar. They also highlight the clean and spacious rooms with beautiful views, the friendly and helpful staff, and the convenient amenities such as free valet parking and keyless check-in.\n\nOther reviews mention the machines can be tight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-7dbf-767c-88cf-9aa7facd15a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7dbf-767c-88cf-9aa7facd15a9",
        "storage_key": "property/6767906449165629/019d7913-7dbf-767c-88cf-9aa7facd15a9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12292203165626239741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-spirit-casino-resort",
      "poi_latitude": "36.0419162",
      "poi_longitude": "-95.9638914",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9186-7328-869e-26162cc3df33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9186-7328-869e-26162cc3df33",
        "storage_key": "property/6767906449165629/019cfb48-9186-7328-869e-26162cc3df33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscNp2cGTtocR_YoV-qatlqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_fc2a143f-1604-4ee8-8b00-776611a2237b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10019 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide range of products, including home goods, electronics, and groceries. They also highlight the clean store, efficient self-checkout, and helpful employees.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-80f1-71ed-8dbe-767a4e270391.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-80f1-71ed-8dbe-767a4e270391",
        "storage_key": "property/6767906449165629/019d7913-80f1-71ed-8dbe-767a4e270391.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/tulsa-south/2542",
      "poi_directions_map_url": "https://maps.google.com/?cid=16722350443478589485&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0190344",
      "poi_longitude": "-95.8836409",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-615-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9190-753f-b75d-8640b2f7a8cc",
        "storage_key": "property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJC2SoWRCOtocRLSAjKSG5Eeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_1fcae417-8041-4a20-b125-a9d6bc155726",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Shopping & Retail",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Global collection of fine & decorative art in an ornate Italian Renaissance-style mansion & gardens.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including traditional and modern pieces, and a beautiful Samurai exhibit. They highlight the stunning architecture, the well-maintained gardens and grounds, and the serene views. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-8a48-7053-9ee4-e936cf6c8c41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8a48-7053-9ee4-e936cf6c8c41",
        "storage_key": "property/6767906449165629/019d7913-8a48-7053-9ee4-e936cf6c8c41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-ab95-74ce-a207-ee6fbc6a1761.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-ab95-74ce-a207-ee6fbc6a1761",
        "storage_key": "property/6767906449165629/019d7913-ab95-74ce-a207-ee6fbc6a1761.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_89c24fd7-0943-44e7-8e0a-62887190c55f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "The Blue Dome",
      "poi_type": "Shopping & Retail",
      "poi_address": "320 E 2nd St S, Tulsa, OK 74120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-922a-7484-b206-73f9c14e0ebf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-922a-7484-b206-73f9c14e0ebf",
        "storage_key": "property/6767906449165629/019d7913-922a-7484-b206-73f9c14e0ebf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bluedomedistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3891437793038114782&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-blue-dome",
      "poi_latitude": "36.1557212",
      "poi_longitude": "-95.9870152",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 918-938-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9186-7328-869e-26162cc3df33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9186-7328-869e-26162cc3df33",
        "storage_key": "property/6767906449165629/019cfb48-9186-7328-869e-26162cc3df33.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTh7bH_rtocR3h-RFw4qATY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_288ccf1f-e244-4e62-a58f-56804a13cbcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "I-44 Antique Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "5111 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-92ca-73a4-a9ac-68073813b0b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-92ca-73a4-a9ac-68073813b0b6",
        "storage_key": "property/6767906449165629/019d7913-92ca-73a4-a9ac-68073813b0b6.webp",
        "width": 960,
        "height": 572
      },
      "poi_business_url": "http://www.facebook.com/I44AntiqueMall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9426199965724178028&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "i-44-antique-mall",
      "poi_latitude": "36.0888",
      "poi_longitude": "-95.974019",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-712-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9190-753f-b75d-8640b2f7a8cc",
        "storage_key": "property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX6xp82aTtocRbPbJOu2W0II",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_7f326e4e-f46c-44bd-aab5-498b95b81548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "River Parks",
      "poi_type": "Shopping & Retail",
      "poi_address": "Riverside Dr, Tulsa, OK 74105, USA",
      "poi_short_description": "Park with a splash pad for kids, plus trails for biking and walking.",
      "poi_long_description": "People say this park offers beautiful walking and biking trails. They highlight the scenic views, vibrant energy, and calm atmosphere. They also like the well-maintained trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-9515-77bf-a89b-d62e11ac0270.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9515-77bf-a89b-d62e11ac0270",
        "storage_key": "property/6767906449165629/019d7913-9515-77bf-a89b-d62e11ac0270.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://riverparks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13339295593307788983&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-parks",
      "poi_latitude": "36.0822916",
      "poi_longitude": "-95.9845085",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-596-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-91c9-774c-9ba6-6c499adf52bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-91c9-774c-9ba6-6c499adf52bd",
        "storage_key": "property/6767906449165629/019cfb48-91c9-774c-9ba6-6c499adf52bd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqXxsR52UtocRt1YL4aqyHrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ff4bad56-4f0c-4431-84a2-d880f844d554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "poi_name": "Utica Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "1709 Utica Square, Tulsa, OK 74114, USA",
      "poi_short_description": "Tree-lined outdoor shopping center open since 1952, featuring upscale chain brands & casual dining.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including popular retail brands, specialty shops, and a Saks Fifth Avenue, as well as numerous dining options. They highlight the beautiful, open-air layout, the convenient parking, and the relaxed and inviting atmosphere. They also like the well-maintained landscaping and seasonal decorations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d7913-9be0-7319-bffb-f155bed60158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9be0-7319-bffb-f155bed60158",
        "storage_key": "property/6767906449165629/019d7913-9be0-7319-bffb-f155bed60158.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uticasquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1952460493464208074&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "utica-square",
      "poi_latitude": "36.1321689",
      "poi_longitude": "-95.9628953",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-588-5209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-9190-753f-b75d-8640b2f7a8cc",
        "storage_key": "property/6767906449165629/019cfb48-9190-753f-b75d-8640b2f7a8cc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAVNNJr_stocRygLrZnmIGBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7cfb963098cb27d3b590eaee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6342004a071a5174397c677a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_41ac13c4748429bd1571a3a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b47de7dcf5ead23b4ccacaa2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a7f631d61bb5010583aada98",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_9e40173141cdf942a796065d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_4da26ea6-bd04-409c-b9cd-c4aa6ae1e807",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "rating": "5.0",
      "name": "Charles",
      "text": "The maintenance guy was friendly and was quick to respond to help on my shower issue. Both him and the office left more than one message telling me what they were doing.",
      "date": "2025-10-07",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_5a1434d7-e93e-4ac8-83e8-8c73af1bd89e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb49-1398-759e-afe0-645d36f3ef38.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a modern apartment kitchen and living area.",
        "public_id": "019cfb49-1398-759e-afe0-645d36f3ef38",
        "storage_key": "property/6767906449165629/019cfb49-1398-759e-afe0-645d36f3ef38.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Sunchase Tulsa Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62ff6240e5632c1bd90e5ace"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-8462-717e-b89f-e494d21e1fd8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "sunchase-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629"
    },
    {
      "lead_collector_id": "019cf79e-84d2-71f9-925d-3fec8339d345",
      "lead_source": "LANDING_PAGE",
      "name": "sunchase-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "generator",
      "page_item_url": "sunchase-apts-tulsa-pool",
      "search_query": "apartments with pool in Tulsa Oklahoma",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Tulsa Oklahoma",
      "h2_subtitle": "Discover the relaxation at Sunchase Apartments with a refreshing pool. Your ideal home in South Tulsa awaits with premium amenities.",
      "page_copy": "Welcome to Sunchase Apartments, where you'll find exceptional living combined with the luxury of a sparkling pool in Tulsa, Oklahoma. Situated in the vibrant South Tulsa neighborhood, our community offers the ideal setting for both relaxation and recreation. Our residents enjoy a variety of amenities, including a clubhouse for social gatherings and a well-equipped fitness center to help achieve your health goals.\n\nAt Sunchase Apartments, experience spacious one- and two-bedroom layouts designed to meet your lifestyle needs. After a busy day, unwind by taking a swim in our pristine pool or savor the tranquility of our serene walking trails. Discover comfort and convenience right here in South Tulsa—your future home is ready for you. Contact us today to learn more or to schedule a tour!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019cfb48-716a-718d-a690-09b935d6484a",
        "storage_key": "property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Tulsa Oklahoma",
      "seo_description": "Discover Sunchase Apartments in Tulsa with a sparkling pool and premium amenities. Choose comfort and convenience in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "generator",
      "page_item_url": "sunchase-apts-south-tulsa-fitness-center",
      "search_query": "fitness center apartments South Tulsa",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments South Tulsa",
      "h2_subtitle": "Experience Sunchase Apartments, offering spacious living and an excellent fitness center. Ideal for those seeking a vibrant lifestyle in South Tulsa.",
      "page_copy": "Sunchase Apartments stands out in South Tulsa for those who prioritize health and convenience. Our on-site fitness center is fully equipped, making it easy to maintain an active lifestyle without leaving home. Nestled in the heart of South Tulsa, Sunchase Apartments offers both one- and two-bedroom layouts with features designed to enhance every resident's comfort.\n\nBeyond the fitness center, you'll appreciate our community amenities like a sparkling pool and serene walking trails, perfect for unwinding and staying active. Our spacious clubhouse sets the stage for community gatherings and socializing, while our laundry facilities and cable-ready options provide additional convenience. Discover how Sunchase Apartments in South Tulsa meets your lifestyle needs. Visit us and see your future home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019cfb48-716a-718d-a690-09b935d6484a",
        "storage_key": "property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments South Tulsa",
      "seo_description": "Explore Sunchase Apartments in South Tulsa for spacious homes and a great fitness center. Enjoy premium amenities and a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "generator",
      "page_item_url": "sunchase-apts-74133-trail-access",
      "search_query": "trail access apartments in 74133",
      "category": "Amenity",
      "h1_title": "Trail Access Apartments in 74133",
      "h2_subtitle": "Sunchase Apartments provides direct access to serene walking trails in the 74133 area. Enjoy the ideal balance of nature and modern living.",
      "page_copy": "Located in the 74133 zip code, Sunchase Apartments offer a harmonious blend of vibrant living with direct access to peaceful walking trails. Embrace the beauty of nature steps from your doorstep, where tranquil paths invite you for morning walks or evening strolls. Our South Tulsa location is perfect for those who appreciate outdoor activities alongside modern conveniences.\n\nChoose from our selection of spacious one- and two-bedroom layouts that are crafted to suit your lifestyle. Besides the scenic trails, our residents enjoy a full suite of amenities, including a fitness center, sparkling pool, and clubhouse for social events. Discover a lifestyle that meshes comfort with natural beauty at Sunchase Apartments. Schedule a tour today and see what makes our community unique, right in the heart of South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019cfb48-716a-718d-a690-09b935d6484a",
        "storage_key": "property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Trail Access Apartments in 74133",
      "seo_description": "Live at Sunchase Apartments in 74133 with direct access to walking trails. Enjoy nature and modern amenities in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "generator",
      "page_item_url": "sunchase-tulsa-air-conditioned-apartments",
      "search_query": "Tulsa apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Tulsa Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool and comfortable at Sunchase Apartments, offering air-conditioned one and two-bedroom homes in Tulsa's vibrant South Tulsa neighborhood.",
      "page_copy": "At Sunchase Apartments in Tulsa, comfort is a priority, which is why our homes are equipped with modern air conditioning systems. Nestled in the lively South Tulsa area, Sunchase Apartments offer a perfect sanctuary from the Oklahoma heat. Beyond the air conditioning, our apartments feature generous one- and two-bedroom layouts designed to cater to various lifestyle needs.\n\nResidents of Sunchase Apartments also enjoy a suite of amenities, including a sparkling swimming pool, a fully-equipped fitness center, and accessible laundry facilities, ensuring convenience and comfort are within reach. Experience the best of Tulsa living with air-conditioned comfort at Sunchase. Schedule a visit today and make Sunchase Apartments your comfortable retreat in South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019cfb48-716a-718d-a690-09b935d6484a",
        "storage_key": "property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tulsa Apartments with Air Conditioning",
      "seo_description": "Experience comfort at Sunchase Apartments with modern air conditioning in South Tulsa. Spacious homes with premium amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "generator",
      "page_item_url": "sunchase-apts-tulsa-dishwasher-included",
      "search_query": "Sunchase Apartments with dishwasher",
      "category": "Amenity",
      "h1_title": "Sunchase Apartments with Dishwasher",
      "h2_subtitle": "Enjoy hassle-free living at Sunchase Apartments where each unit includes a dishwasher. Discover the ease of modern living in South Tulsa.",
      "page_copy": "Sunchase Apartments in South Tulsa ensures that your lifestyle is as convenient as possible by including dishwashers in every apartment. Whether you choose a spacious one or two-bedroom layout, you will experience the ease of effortless dish cleanup, giving you more time to enjoy the beautiful surroundings and community amenities.\n\nLiving at Sunchase Apartments means enjoying more than just a dishwasher. Our community boasts a sparkling pool for sunny days, a well-equipped fitness center for staying active, and idyllic walking trails perfect for a morning jog or a leisurely evening walk. Make Sunchase Apartments, located in the heart of South Tulsa, your choice for comfortable and convenient living. Plan your visit today and see the difference modern appliances can make!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019cfb48-716a-718d-a690-09b935d6484a",
        "storage_key": "property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sunchase Apartments with Dishwasher",
      "seo_description": "Discover Sunchase Apartments in South Tulsa, where each unit includes a dishwasher for modern convenience. Enjoy a comfortable and hassle-free lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "generator",
      "page_item_url": "south-tulsa-one-bedroom-sunchase-apartments",
      "search_query": "one bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments South Tulsa",
      "h2_subtitle": "Discover charming one bedroom apartments at Sunchase in South Tulsa. Perfect for a cozy and modern lifestyle with fantastic amenities.",
      "page_copy": "In the vibrant heart of South Tulsa, Sunchase Apartments offers beautifully designed one-bedroom units that combine comfort and convenience. Ideal for singles or couples, these apartments provide a modern sanctuary complete with all the essential features you need. Each one-bedroom unit is spacious and thoughtfully designed, ensuring a perfect blend of style and functionality.\n\nAt Sunchase Apartments, convenience extends beyond your front door. Residents enjoy access to wonderful community amenities such as a sparkling pool, fitness center, and peaceful walking trails. Located close to all that South Tulsa has to offer, Sunchase Apartments makes it easy to enjoy a balanced lifestyle. Experience the perfect blend of urban living and serene surroundings by making one of our one-bedroom apartments your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019cfb48-716a-718d-a690-09b935d6484a",
        "storage_key": "property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments South Tulsa",
      "seo_description": "Explore one bedroom apartments at Sunchase in South Tulsa. Enjoy modern living with great amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165629",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-tulsa-sunchase",
      "search_query": "two bedroom apartments tulsa ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Tulsa OK",
      "h2_subtitle": "Explore spacious two bedroom apartments at Sunchase in Tulsa, OK. Ideal for families or roommates seeking comfort and style.",
      "page_copy": "Sunchase Apartments is proud to offer spacious two-bedroom layouts in the bustling city of Tulsa, OK. These apartments are perfect for families or roommates seeking a comfortable and stylish living space. Each unit is designed with ample room and thoughtful details, providing a welcoming atmosphere you’ll love to call home.\n\nBeyond individual apartments, Sunchase provides amenities that enhance residents' lifestyles. From a refreshing pool and state-of-the-art fitness center to serene walking trails, there is something for everyone. Located in South Tulsa, our community combines the advantages of city living with a peaceful neighborhood ambiance. Visit Sunchase Apartments today and discover how our two-bedroom units can be the perfect fit for your living needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
      "featured_image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019cfb48-716a-718d-a690-09b935d6484a",
        "storage_key": "property/6767906449165629/019cfb48-716a-718d-a690-09b935d6484a.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Tulsa OK",
      "seo_description": "Find spacious two bedroom apartments at Sunchase in Tulsa, OK. Enjoy modern living with first-class amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5219"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-4K1DK1FLFT"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041152078"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/sunchase-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WKLNFV9L"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165629/019d1bd9-f8c1-74ea-a039-3d395d5d60a4.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "36087948650"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "515a8283-0525-46d7-9c01-2bcbe830b66c"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-533-2974"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64651dbcf1c79e9da252055b"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImV4MEpwdU9lUzNiQUNlNFB0NklCOFE9PSIsInZhbHVlIjoiTWxxVXZ2L1lSWXQyc3NZeEtrV28rZz09IiwibWFjIjoiN2NmMzQ1ZTczYmZjZTJkMmE5ZDA4ZDhiY2UwYzhmZDkwOTEzNGE0NTQ3ZjI1NDIyZWZlYmQxNDYyMzJlNzAyMSJ9"
    }
  ],
  "custom_qb_id": "5219",
  "custom_ga4_id": "G-4K1DK1FLFT",
  "custom_repli_id": "10041152078",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/sunchase-apartments/register/",
  "custom_google_gtm_id": "GTM-WKLNFV9L",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165629/019d1bd9-f8c1-74ea-a039-3d395d5d60a4.pdf",
  "custom_hubspot_company_id": "36087948650",
  "custom_rentgrata_property_id": "515a8283-0525-46d7-9c01-2bcbe830b66c",
  "custom_ppc_tracking_phone_number": "855-533-2974",
  "custom_residentboost_apartment_id": "64651dbcf1c79e9da252055b",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImV4MEpwdU9lUzNiQUNlNFB0NklCOFE9PSIsInZhbHVlIjoiTWxxVXZ2L1lSWXQyc3NZeEtrV28rZz09IiwibWFjIjoiN2NmMzQ1ZTczYmZjZTJkMmE5ZDA4ZDhiY2UwYzhmZDkwOTEzNGE0NTQ3ZjI1NDIyZWZlYmQxNDYyMzJlNzAyMSJ9"
};

export const generatedAt = '2026-08-27T21:36:12.918Z';
